import { Helper } from "@/Utility";

class DashboardController {
  static InitialState = {
    HaveData: false,
    AllowedCustomers: null,
    IsRefetch: false,
    Counter: {
      User: 0,
      Customer: 0,
      Contract: 0,
      Section: 0,
      SubSection: 0,
      SubSectionSub: 0,
      Nitch: 0,
      Interest: 0,
      Branch: 0,
      Team: 0,
      Package: 0,
    },
    Section: [],
    SubSection: [],
    SubSectionSub: [],
    Nitch: [],
    Interest: [],
    Branch: [],
    Team: [],
    Package: [],
    SubPackage: [],
    Role: [],
    Classification: [],
    Permission: [],
    Status: [],
    Sales: [],
    Accounts: [],
    AccountManager: [],
    Technical: [],
    ProductType: [],
    ContactWay: [],
    Platform: [],
    Position: [],
    Directory: [],
  };
  static SetDashboardData(state, action) {
    return {
      ...state,
      ...action.payload,
    };
  }
  static ResetDashboardData() {
    return this.InitialState;
  }
  // SubPackage
  static AddSubPackage(state, action) {
    const NewData = [...state.SubPackage, action.payload];
    state.SubPackage = NewData;
  }
  static RemoveSubPackage(state, action) {
    try {
      if (!Array.isArray(state.SubPackage)) {
        throw new Error("SubPackage is not an array");
      }
      const OldData = [...state.SubPackage];
      const NewData = OldData.filter(
        (item) => item.SubPackageId !== action.payload
      );
      state.SubPackage = NewData;
    } catch (error) {
      //
    }
  }
  static UpdateSubPackage(state, action) {
    try {
      if (!Array.isArray(state.SubPackage)) {
        throw new Error("SubPackage is not an array");
      }
      const OldData = [...state.SubPackage];
      const NewData = OldData.map((item) => {
        if (item.SubPackageId === action.payload.SubPackageId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.SubPackage = NewData;
    } catch (error) {
      //
    }
  }
  // Section
  static AddSection(state, action) {
    const newSections = [...state.Section, action.payload];
    state.Counter.Section++;
    state.Section = newSections;
  }
  static UpdateSection(state, action) {
    try {
      if (!Array.isArray(state.Section)) {
        throw new Error("Section is not an array");
      }
      const oldData = [...state.Section];
      const newData = oldData.map((item) => {
        if (item.SectionId === action.payload.SectionId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Section = newData;
    } catch (error) {
      //
    }
  }
  static RemoveSection(state, action) {
    try {
      if (!Array.isArray(state.Section)) {
        throw new Error("Section is not an array");
      }
      const oldData = [...state.Section];
      const newData = oldData.filter(
        (item) => item.SectionId !== action.payload
      );
      state.Counter.Section--;
      state.Section = newData;
    } catch (error) {
      //
    }
  }
  // Sub Section
  static AddSubSection(state, action) {
    const newSubSections = [...state.SubSection, action.payload];
    state.Counter.SubSection++;
    state.SubSection = newSubSections;
  }
  static UpdateSubSection(state, action) {
    try {
      if (!Array.isArray(state.SubSection)) {
        throw new Error("SubSection is not an array");
      }
      const oldData = [...state.SubSection];
      const newData = oldData.map((item) => {
        if (item.SubSectionId === action.payload.SubSectionId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.SubSection = newData;
    } catch (error) {
      //
    }
  }
  static RemoveSubSection(state, action) {
    try {
      if (!Array.isArray(state.SubSection)) {
        throw new Error("SubSection is not an array");
      }
      const oldData = [...state.Section];
      const newData = oldData.filter(
        (item) => item.SubSectionId !== action.payload
      );
      state.Counter.SubSection--;
      state.SubSection = newData;
    } catch (error) {
      //
    }
  }
  // SubSectionSub
  static AddSubSectionSub(state, action) {
    const newSubSections = [...state.SubSectionSub, action.payload];
    state.Counter.SubSectionSub++;
    state.SubSectionSub = newSubSections;
  }
  static RemoveSubSectionSub(state, action) {
    try {
      if (!Array.isArray(state.SubSectionSub)) {
        throw new Error("SubSectionSub is not an array");
      }
      const oldData = [...state.Section];
      const newData = oldData.filter(
        (item) => item.SubSectionSubId !== action.payload
      );
      state.Counter.SubSectionSub--;
      state.SubSectionSub = newData;
    } catch (error) {
      //
    }
  }
  static UpdateSubSectionSub(state, action) {
    try {
      if (!Array.isArray(state.SubSectionSub)) {
        throw new Error("SubSectionSub is not an array");
      }
      const oldData = [...state.SubSectionSub];
      const newData = oldData.map((item) => {
        if (item.SubSectionSubId === action.payload.SubSectionSubId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.SubSectionSub = newData;
    } catch (error) {
      //
    }
  }
  // Position
  static AddPosition(state, action) {
    const newData = [...state.Position, action.payload];
    state.Position = newData;
  }
  static UpdatePosition(state, action) {
    try {
      if (!Array.isArray(state.Position)) {
        throw new Error("Position is not an array");
      }
      const oldData = [...state.Position];
      const newData = oldData.map((item) => {
        if (item.PositionId === action.payload.PositionId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Position = newData;
    } catch (error) {
      //
    }
  }
  static RemovePosition(state, action) {
    try {
      if (!Array.isArray(state.Position)) {
        throw new Error("Position is not an array");
      }
      const oldData = [...state.Position];
      const newData = oldData.filter(
        (item) => item.PositionId !== action.payload
      );
      state.Position = newData;
    } catch (error) {
      //
    }
  }
  // ProductType
  static AddProductType(state, action) {
    const newData = [...state.ProductType, action.payload];
    state.ProductType = newData;
  }
  static UpdateProductType(state, action) {
    try {
      if (!Array.isArray(state.ProductType)) {
        throw new Error("ProductType is not an array");
      }
      const oldData = [...state.ProductType];
      const newData = oldData.map((item) => {
        if (item.ProductTypeId === action.payload.ProductTypeId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.ProductType = newData;
    } catch (error) {
      //
    }
  }
  static RemoveProductType(state, action) {
    try {
      if (!Array.isArray(state.ProductType)) {
        throw new Error("ProductType is not an array");
      }
      const oldData = [...state.ProductType];
      const newData = oldData.filter(
        (item) => item.ProductTypeId !== action.payload
      );
      state.ProductType = newData;
    } catch (error) {
      //
    }
  }
  // ContactWay
  static AddContactWay(state, action) {
    const newData = [...state.ContactWay, action.payload];
    state.ContactWay = newData;
  }
  static UpdateContactWay(state, action) {
    try {
      if (!Array.isArray(state.ContactWay)) {
        throw new Error("ContactWay is not an array");
      }
      const oldData = [...state.ContactWay];
      const newData = oldData.map((item) => {
        if (item.ContactWayId === action.payload.ContactWayId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.ContactWay = newData;
    } catch (error) {
      //
    }
  }
  static RemoveContactWay(state, action) {
    try {
      if (!Array.isArray(state.ContactWay)) {
        throw new Error("ContactWay is not an array");
      }
      const oldData = [...state.ContactWay];
      const newData = oldData.filter(
        (item) => item.ContactWayId !== action.payload
      );
      state.ContactWay = newData;
    } catch (error) {
      //
    }
  }
  // Platform
  static AddPlatform(state, action) {
    const newData = [...state.Platform, action.payload];
    state.Platform = newData;
  }
  static UpdatePlatform(state, action) {
    try {
      if (!Array.isArray(state.Platform)) {
        throw new Error("Platform is not an array");
      }
      const oldData = [...state.Platform];
      const newData = oldData.map((item) => {
        if (item.PlatformId === action.payload.PlatformId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Platform = newData;
    } catch (error) {
      //
    }
  }
  static RemovePlatform(state, action) {
    try {
      if (!Array.isArray(state.Platform)) {
        throw new Error("Platform is not an array");
      }
      const oldData = [...state.Platform];
      const newData = oldData.filter(
        (item) => item.PlatformId !== action.payload
      );
      state.Platform = newData;
    } catch (error) {
      //
    }
  }
  // Nitch
  static AddNitch(state, action) {
    const newNitchs = [...state.Nitch, action.payload];
    state.Counter.Nitch++;
    state.Nitch = newNitchs;
  }
  static UpdateNitch(state, action) {
    try {
      if (!Array.isArray(state.Nitch)) {
        throw new Error("Nitch is not an array");
      }
      const oldData = [...state.Nitch];
      const newData = oldData.map((item) => {
        if (item.NitchId === action.payload.NitchId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Nitch = newData;
    } catch (error) {
      //
    }
  }
  static RemoveNitch(state, action) {
    try {
      if (!Array.isArray(state.Nitch)) {
        throw new Error("state.Nitch is not an array");
      }
      const oldNitch = [...state.Nitch];
      const newNitchs = oldNitch.filter(
        (item) => item.NitchId !== action.payload
      );

      state.Counter.Nitch--;
      state.Nitch = newNitchs;
    } catch (error) {
      //
    }
  }
  // Interest
  static AddInterest(state, action) {
    const newInterests = [...state.Interest, action.payload];
    state.Counter.Interest++;
    state.Interest = newInterests;
  }
  static UpdateInterest(state, action) {
    try {
      if (!Array.isArray(state.Interest)) {
        throw new Error("Interest is not an array");
      }
      const oldData = [...state.Interest];
      const newData = oldData.map((item) => {
        if (item.InterestId === action.payload.InterestId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Interest = newData;
    } catch (error) {
      //
    }
  }
  static RemoveInterest(state, action) {
    try {
      if (!Array.isArray(state.Interest)) {
        throw new Error("state.Interest is not an array");
      }
      const oldInterest = [...state.Interest];
      const newInterests = oldInterest.filter(
        (item) => item.InterestId !== action.payload
      );

      state.Counter.Interest--;
      state.Interest = newInterests;
    } catch (error) {
      //
    }
  }
  // Branch
  static AddBranch(state, action) {
    const NewData = [...state.Branch, action.payload];
    state.Counter.Branch++;
    state.Branch = NewData;
  }
  static UpdateBranch(state, action) {
    try {
      if (!Array.isArray(state.Branch)) {
        throw new Error("Branch is not an array");
      }
      const oldData = [...state.Branch];
      const newData = oldData.map((item) => {
        if (item.BranchId === action.payload.BranchId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Branch = newData;
    } catch (error) {
      //
    }
  }
  static RemoveBranch(state, action) {
    try {
      if (!Array.isArray(state.Branch)) {
        throw new Error("state.Branch is not an array");
      }
      const oldData = [...state.Branch];
      const newData = oldData.filter(
        (item) => item.BranchId !== action.payload
      );

      state.Counter.Branch--;
      state.Branch = newData;
    } catch (error) {
      //
    }
  }
  // Team
  static AddTeam(state, action) {
    const NewData = [...state.Team, action.payload];
    state.Counter.Team++;
    state.Team = NewData;
  }
  static UpdateTeam(state, action) {
    try {
      if (!Array.isArray(state.Team)) {
        throw new Error("Team is not an array");
      }
      const oldData = [...state.Team];
      const newData = oldData.map((item) => {
        if (item.TeamId == action.payload.TeamId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Team = newData;
    } catch (error) {
      //
    }
  }
  static RemoveTeam(state, action) {
    try {
      if (!Array.isArray(state.Team)) {
        throw new Error("state.Team is not an array");
      }
      const oldData = [...state.Team];
      const newData = oldData.filter((item) => item.TeamId !== action.payload);

      state.Counter.Team--;
      state.Team = newData;
    } catch (error) {
      //
    }
  }
  // Package
  static AddPackage(state, action) {
    const newPackages = [...state.Package, action.payload];
    state.Counter.Package++;
    state.Package = newPackages;
  }
  static UpdatePackage(state, action) {
    try {
      if (!Array.isArray(state.Package)) {
        throw new Error("Package is not an array");
      }
      const oldData = [...state.Package];
      const newData = oldData.map((item) => {
        if (item.PackageId === action.payload.PackageId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Package = newData;
    } catch (error) {
      //
    }
  }
  static RemovePackage(state, action) {
    try {
      if (!Array.isArray(state.Package)) {
        throw new Error("Package is not an array");
      }
      const oldData = [...state.Section];
      const newData = oldData.filter(
        (item) => item.PackageId !== action.payload
      );
      state.Counter.Package--;
      state.Package = newData;
    } catch (error) {
      //
    }
  }
  // Role
  static AddRole(state, action) {
    const newRoles = [...state.Role, action.payload];
    state.Role = newRoles;
  }
  static UpdateRole(state, action) {
    try {
      if (!Array.isArray(state.Role)) {
        throw new Error("Role is not an array");
      }
      const oldData = [...state.Role];
      const newData = oldData.map((item) => {
        if (item.RoleId === action.payload.RoleId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Role = newData;
    } catch (error) {
      //
    }
  }
  static RemoveRole(state, action) {
    try {
      if (!Array.isArray(state.Role)) {
        throw new Error("Role is not an array");
      }
      const oldData = [...state.Section];
      const newData = oldData.filter((item) => item.RoleId !== action.payload);
      state.Role = newData;
    } catch (error) {
      //
    }
  }
  // Classification
  static AddClassification(state, action) {
    const newClassifications = [...state.Classification, action.payload];
    state.Classification = newClassifications;
  }
  static UpdateClassification(state, action) {
    try {
      if (!Array.isArray(state.Classification)) {
        throw new Error("Classification is not an array");
      }
      const oldData = [...state.Classification];
      const newData = oldData.map((item) => {
        if (item.ClassificationId === action.payload.ClassificationId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Classification = newData;
    } catch (error) {
      //
    }
  }
  static RemoveClassification(state, action) {
    try {
      if (!Array.isArray(state.Classification)) {
        throw new Error("Classification is not an array");
      }
      const oldData = [...state.Section];
      const newData = oldData.filter(
        (item) => item.ClassificationId !== action.payload
      );
      state.Classification = newData;
    } catch (error) {
      //
    }
  }
  // Status
  static AddStatus(state, action) {
    const newStatuses = [...state.Status, action.payload];
    state.Status = newStatuses;
  }
  static UpdateStatus(state, action) {
    try {
      if (!Array.isArray(state.Status)) {
        throw new Error("Status is not an array");
      }
      const oldData = [...state.Status];
      const newData = oldData.map((item) => {
        if (item.StatusId === action.payload.StatusId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Status = newData;
    } catch (error) {
      //
    }
  }
  static RemoveStatus(state, action) {
    try {
      if (!Array.isArray(state.Status)) {
        throw new Error("Status is not an array");
      }
      const oldData = [...state.Status];
      const newData = oldData.filter(
        (item) => item.StatusId !== action.payload
      );
      state.Status = newData;
    } catch (error) {
      //
    }
  }
  // User
  static AddUser(state, action) {
    let U = action.payload;
    const DataToAddSections = {
      UserId: U.UserId || null,
      UserName: U.UserName || null,
      UserRole: U.UserRole?.RoleName?.trim() || null,
      UserSection: U.UserSection?.SectionKey?.trim() || null,
      UserSubSection: U.UserSubSection?.SubSectionKey?.trim() || null,
      UserSubSectionSub: U.UserSubSectionSub?.SubSectionSubKey?.trim() || null,
      UserStatus: U.UserStatus?.StatusName?.trim() || null,
    };
    const UserSection = Helper.SectionSelection(U.UserSection.SectionId);
    if (UserSection) {
      state[UserSection] = [...state[UserSection], DataToAddSections];
    }
    state.Counter.User++;
  }
  static UpdateUser(state, action) {
    try {
      let U = action.payload;
      const UserSection = U.UserSection?.SectionKey?.trim();
      let oldSec = [...state[UserSection]];
      const DataToAddSections = {
        UserId: U.UserId || null,
        UserName: U.UserName || null,
        UserRole: U.UserRole?.RoleName?.trim() || null,
        UserSection: UserSection || null,
        UserSubSection: U.UserSubSection?.SubSectionKey?.trim() || null,
        UserSubSectionSub:
          U.UserSubSectionSub?.SubSectionSubKey?.trim() || null,
        UserStatus: U.UserStatus?.StatusName?.trim() || null,
        UserBranchId: U.UserBranch ? U.UserBranch?.BranchId : null,
        UserTeamId: U.UserTeam ? U.UserTeam?.TeamId : null,
      };
      let newData = oldSec;
      if (U?.IsSameBranch) {
        const isIn = oldSec.find((item) => item.UserId == U.UserId);
        if (!isIn) {
          newData = [...oldSec, DataToAddSections];
        } else {
          newData = oldSec.map((item) => {
            if (item.UserId == U.UserId) {
              return DataToAddSections;
            }
            return item;
          });
        }
      } else {
        // remove from old section
        newData = oldSec = oldSec.filter((item) => item.UserId != U.UserId);
      }
      state[UserSection] = newData;
    } catch (error) {
      //
    }
  }
  static RemoveUser(state, action) {
    try {
      if (!Array.isArray(state.Status)) {
        throw new Error("Status is not an array");
      }
      state.Sales = [...state.Sales].filter(
        (item) => item.UserId !== action.payload
      );
      state.Accounts = [...state.Accounts].filter(
        (item) => item.UserId !== action.payload
      );
      state.AccountManager = [...state.AccountManager].filter(
        (item) => item.UserId !== action.payload
      );
      state.Technical = [...state.Technical].filter(
        (item) => item.UserId !== action.payload
      );
      state.Counter.User--;
    } catch (error) {
      //
    }
  }
  // Customer
  static AddCustomer(state) {
    state.Counter.Customer++;
  }
  static RemoveCustomer(state) {
    state.Counter.Customer--;
  }
  // Contract
  static AddContract(state) {
    state.Counter.Contract++;
  }
  static RemoveContract(state) {
    state.Counter.Contract--;
  }
  // Directory
  static AddDirectory(state, action) {
    const NewData = [...state.Directory, action.payload];
    state.Directory = NewData;
  }
  static UpdateDirectory(state, action) {
    try {
      if (!Array.isArray(state.Directory)) {
        throw new Error("Directory is not an array");
      }
      const OldData = [...state.Directory];
      const NewData = OldData.map((item) => {
        if (item.DirId == action.payload.DirId) {
          return action.payload;
        } else {
          return item;
        }
      });
      state.Directory = NewData;
    } catch (error) {
      //
    }
  }
  static RestoreDirectory(state, action) {
    try {
      state.Directory = action.payload;
    } catch (error) {
      //
    }
  }
  static RemoveDirectory(state, action) {
    try {
      if (!Array.isArray(state.Directory)) {
        throw new Error("Directory is not an array");
      }
      const OldData = [...state.Directory];
      const NewData = OldData.filter((item) => item.DirId != action.payload);
      state.Directory = NewData;
    } catch (error) {
      //
    }
  }
}
export default DashboardController;
